import {
  SET_EXPERIMENT_CYBER,
  CLEAN_EXPERIMENTS,
  SET_EXPERTIMENT_TRIPS_DISCOUNT,
  SET_EXPERIMENT_BENEFITS,
  SET_EXPERIMENT_MAINTENANCE_SCREEN,
} from "../types/experiment";

const initialState = {
  experimentCyber: {
    isActive: false,
    startDate: null,
    endDate: null,
  },
  experimentDiscountTrips: false,
  experimentBenefits: null,
  experimentMaintenanceScreen: false,
  discountExperimentTrips: null,
};

const experimentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EXPERIMENT_CYBER:
      return {
        ...state,
        experimentCyber: action.payload,
      };
    case SET_EXPERIMENT_BENEFITS:
      return {
        ...state,
        experimentBenefits: action.payload,
      };
    case SET_EXPERTIMENT_TRIPS_DISCOUNT:
      return {
        ...state,
        experimentDiscountTrips: action.payload.isActive,
        discountExperimentTrips: action.payload.discount,
      }
    case SET_EXPERIMENT_MAINTENANCE_SCREEN:
      return {
        ...state,
        experimentMaintenanceScreen: action.payload,
      }
    case CLEAN_EXPERIMENTS:
      return {
        ...initialState,
        experimentBenefits: state.experimentBenefits,
      };
    default:
      return state;
  }
};

export default experimentReducer;
